/**
 * Parse a raw URL string into a label of the form "hostname/pathname".
 * If the input is empty or not a valid URL, returns an empty string or the original input.
 * Great for use labeling URLs as links.
 *
 * @param rawUrl - The URL string to parse.
 * @returns The concatenated hostname and pathname, or the original rawUrl if parsing fails, or "" if rawUrl is empty.
 */
export function parseUrlLabel(rawUrl: string): string {
  if (!rawUrl.trim()) {
    return "";
  }

  try {
    const parsed = new URL(rawUrl);
    const pathname = parsed.pathname.replace(/\/$/, "");
    return `${parsed.hostname}${pathname}`;
  } catch {
    // malformed URL—just return it back
    return rawUrl;
  }
}
